export default __webpack_public_path__ + "static/media/mitigation-finished-ceiling-removal.6c0b2d0c.jpg";